import Vue from "vue";
import _ from "lodash";
import qs from "qs";
import moment from "moment";

const URL = "/db/materi";
const API_URL = URL + "/api/";

const state = {
  materi: [],
  materi_loaded: false,
  materi_init: true
};

const getters = {
  materiInjected(state) {
    return _.cloneDeep(state.materi).map(data => {
      data.total_training = data.training.length;
      return data;
    });
  },
  materiByLaman(state, getters, rootState) {
    return state.materi.filter(o => o.id_laman == rootState.id_laman$);
  },
  materiByLamanPeriode(state, getters, rootState) {
    let materi = _.cloneDeep(
      state.materi.filter(o => o.id_laman == rootState.id_laman$)
    );
    return materi.map(data => {
      data.training = data.training.filter(tr => {
        let bool = true;
        if (moment(rootState.periode$).isValid()) {
          bool = moment(tr.waktu_mulai).format("YYYY") == rootState.periode$;
        }
        return bool;
      });
      data.total_training = data.training.length;
      return data;
    });
  }
};

const mutations = {
  INIT(state) {
    if (state.materi_init) state.materi_init = false;
  },
  LOADED(state, payload) {
    state.materi_loaded = payload;
  },
  SET_MATERI(state, payload) {
    state.materi = payload;
  },
  ADD_MATERI(state, payload) {
    state.materi.push(payload);
  },
  UPDATE_MATERI(state, payload) {
    state.materi = _.unionBy([payload], state.materi, "id_materi");
  },
  DELETE_MATERI(state, ids) {
    _.remove(state.materi, function(materi) {
      return ids.includes(materi.id_materi);
    });
    state.materi = [...state.materi];
  }
};

const actions = {
  GET_OPTIONS({ commit }) {
    commit("LOADING", null, { root: true });
    return Vue.axios.get(URL + "/options").then(res => {
      commit("laman/SET_LAMAN", res.data.laman, { root: true });
      commit("LOADING_DONE", null, { root: true });
    });
  },
  GET_MATERI({ commit }) {
    commit("LOADING", null, { root: true });
    commit("LOADED", false);
    return Vue.axios.get(API_URL).then(res => {
      commit("INIT");
      commit("LOADED", true);
      commit("SET_MATERI", res.data);
      commit("LOADING_DONE", null, { root: true });
    });
  },
  ADD_MATERI({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(API_URL, qs.stringify(payload))
      .then(res => {
        commit("ADD_MATERI", res.data);
        commit("SUCCESS", "Berhasil menambah...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  },
  UPDATE_MATERI({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .put(API_URL + payload.id_materi, qs.stringify(payload))
      .then(res => {
        commit("UPDATE_MATERI", res.data);
        commit("SUCCESS", "Berhasil mengupdate...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  },
  DELETE_MATERI({ commit }, payload) {
    let ids = payload.map(p => p.id_materi).join(",");
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .delete(API_URL + ids)
      .then(res => {
        commit("DELETE_MATERI", res.data.ids);
        if (typeof res.data.errors !== "undefined")
          commit("ERROR", res.data.errors, { root: true });
        else commit("SUCCESS", "Berhasil menghapus...", { root: true });
        return res.data.ids;
      })
      .catch(() => {
        commit("ERROR", "Data masih dipakai di tabel lain!", {
          root: true
        });
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
